<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-attendance'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-monitoring-attendance"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(type)="data">
            <b-badge
              pill
              :variant="`light-${
                data.value == 'Employee' ? 'warning' : 'success'
              }`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(name)="data">
            <span>{{ data.value | capitalize }}</span>
          </template>
          <template #cell(json_users)="data">
            <b-badge
              v-for="item in JSON.parse(data.value)"
              :key="item.id"
              pill
              :variant="`light-primary`"
              class="mr-1"
            >
              <span> {{ item.user_name | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(id)="data">
            <feather-icon
              @click="editEntityGroup(data.item)"
              icon="EditIcon"
              size="17"
              class="cursor-pointer text-warning"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <EntityGroupModal
      v-if="entityGroupModal"
      :dataModal="dataModal"
      @hideModal="hideEntityGroupModal"
    />
  </div>
</template>

<script>
/* Data */
import Fields from "@/views/settings/views/entity-group/data/fields.data.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* Modals */
import EntityGroupModal from "@/views/settings/views/entity-group/components/modals/EntityGroupModal.vue";

/* Services */
import EntityGroupService from "@/views/settings/views/entity-group/service/entity-group.service.js";

import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    EntityGroupModal,
  },
  data() {
    return {
      filters: [],
      params: 1,
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      entityGroupModal: false,
      dataModal: {},
    };
  },
  computed: {
    showFields() {
      return Fields.map((item) => ({ ...item, label: this.$t(item.label) }));
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    fields() {
      return Fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },
  },
  created() {},
  methods: {
    async myProvider(ctx) {
      try {
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
        };
        const { data } = await EntityGroupService.getEntityGroup(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },
    editEntityGroup(item, is_new = false) {
      if (is_new == true) {
        this.dataModal = {
          id: null,
          type: null,
          name: "",
          json_users: JSON.stringify([]),
        };
        this.entityGroupModal = true;
      } else {
        this.dataModal = item;
        this.entityGroupModal = true;
      }
    },
    hideEntityGroupModal(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-attendance"].refresh();
        this.entityGroupModal = false;
        return;
      }
      this.entityGroupModal = false;
    },
  },
};
</script>

<style>
</style>